import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StatusBadgeColourScheme } from '../../../../controls/status-badge/status-badge-constants';
import { SDBallotStatus } from '../../../../../shared/constants/sd-ballot.constants';
import { appConstants } from '../../../../../shared/constants/app-constants';

@Component({
    selector: 'app-sd-ballot-status-badge',
    templateUrl: './sd-ballot-status-badge.component.html',
    styleUrl: './sd-ballot-status-badge.component.scss',
    standalone: false
})
export class SdBallotStatusBadgeComponent {
  @Input() sdBallotStatus: string = '';
  statusText: string = '';
  notStart: string = appConstants.CommentAndBallotStatus.notStart;
  open: string = appConstants.CommentAndBallotStatus.open;
  closed: string = appConstants.CommentAndBallotStatus.closed;
  public statusBadgeColourSchemeEnum: StatusBadgeColourScheme = StatusBadgeColourScheme.Green;


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sdBallotStatus']) {
      this.statusText = this.getSDBallotStatusText(this.sdBallotStatus);
      this.statusBadgeColourSchemeEnum = this.getSDBallotStatusColourScheme(this.sdBallotStatus);
    }
  }

  getSDBallotStatusText(sdBallotStatus: string): string {
    switch (sdBallotStatus) {
      case undefined:
      case null:
      case '':
      case SDBallotStatus.NotOpen:
        return this.notStart;
      case SDBallotStatus.Open:
        return this.open;
      default:
        return this.closed;
    }
  }

  getSDBallotStatusColourScheme(sdBallotStatus: string): StatusBadgeColourScheme {
    switch (sdBallotStatus) {
      case SDBallotStatus.Open:
        return StatusBadgeColourScheme.Green;
      default:
        return StatusBadgeColourScheme.Red;
    }
  }
}







